import { render, staticRenderFns } from "./WaterOnPaperDryMassChart.vue?vue&type=template&id=64bad600&scoped=true&"
import script from "./WaterOnPaperDryMassChart.vue?vue&type=script&lang=js&"
export * from "./WaterOnPaperDryMassChart.vue?vue&type=script&lang=js&"
import style0 from "./WaterOnPaperDryMassChart.vue?vue&type=style&index=0&id=64bad600&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64bad600",
  null
  
)

export default component.exports